import React from 'react';
import style from './index.scss';
import {
  Layout,
  PageHeader,
  Select,
  Space,
  Table,
  Tabs,
  Input,
  Button,
  Menu,
  Dropdown
} from 'antd';
import RightCaret from '../../../assets/right_caret.png';
import TRMDrawer, { typologyTabsConfig } from '../typologyInstanceDrawer';
import { CustomHeader } from '../components/CustomHeaderComponent/customHeader';
import {
  AddToBucketComponent,
  NotesComponent,
  TextComponent,
  TTButton
} from '../components/TableComponents';
import RunInstanceHandlerClass from './runInstanceHandlerClass';
import { UploadOutlined, FilterOutlined } from '@ant-design/icons';
import { convertISOToDateFormat } from '../../../util/timezone';
import { returnFraudUserAccessByResource } from '../../../util/TmFraudModuleFilter';
import {
  ITEM_OPERATIONS,
  TM_FRAUD_PREVENTION_SOURCE_MAPPING,
  TM_FRAUD_SOURCE_IDS
} from '../../../util/GlobalConstant';
import { hasAttributeValue } from '../../../util';
import { getSelectedResources } from '../../../util/resourceManager';

const { Header, Content, Footer } = Layout;
const { TabPane } = Tabs;
const { trmResources } = getSelectedResources();

const FilterMenu = ({
  detectionAccess,
  fraudAccess,
  preventionAccess,
  onMenuClick
}) => {
  const handleMenuClick = (e) => {
    onMenuClick(e.key);
  };

  return (
    <Menu onClick={(e) => handleMenuClick(e)}>
      {(detectionAccess && fraudAccess) ||
      (detectionAccess && preventionAccess) ? (
        <Menu.Item key="All">All</Menu.Item>
      ) : null}
      {detectionAccess && <Menu.Item key="TM">TM</Menu.Item>}
      {fraudAccess && <Menu.Item key="Fraud">Fraud</Menu.Item>}
      {preventionAccess && (
        <Menu.Item key="Surveillance">Surveillance</Menu.Item>
      )}
      {/* Add more filter options as needed */}
    </Menu>
  );
};

/**
 * TRM_Dashboard Class
 */
class TRM_Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddGroupModalShown: false,
      groups: [],
      trmTypologies: [],
      defaultCurrent: 1,
      pageSize: 20,
      showRunInstanceModal: false,
      selectedTypology: '',
      isFraud: false,
      isTMuser: false,
      isTmFraudUniversalUser: false,
      currentSelectedFilter: '',
      preventionAccess: false,
      detectionAccess: false,
      fraudAccess: false,
      currentModuleSource: '',
      searchQuery: ''
    };
    this.drawerRef = React.createRef();
    this.columns = [
      {
        title: '',
        className: style.bgWhite,
        width: '5%',
        render: (typology) => (
          <AddToBucketComponent
            {...typology}
            onAddTypologyToScenario={this.onAddTypologyToRunInstance}
          />
        )
      },
      {
        title: <CustomHeader title={'Typology ID'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '10%',
        render: (typology) => (
          <TextComponent style={{ color: '#0C8ED7' }} id={typology.id} />
        )
      },
      {
        title: <CustomHeader title={'Typology Name'} />,
        dataIndex: 'typology',
        width: '35%',
        className: style.bgWhite,
        key: 'typology',
        render: (typology) => <TextComponent id={typology.title} />
      },
      {
        title: <CustomHeader title={'Notes'} />,
        dataIndex: 'notes',
        width: '10%',
        className: style.bgWhite,
        key: 'notes',
        render: (notes) => <NotesComponent notes={notes} />
      },
      {
        title: <CustomHeader title={'Creator'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '10%',
        render: (typology) => <TextComponent id={typology.createdBy} />
      },
      {
        title: <CustomHeader title={'Run Instances'} />,
        dataIndex: 'scenarios',
        className: style.bgWhite,
        key: 'scenarios',
        width: '8%',
        render: (scenarios) => <TextComponent id={scenarios} />
      },
      {
        title: <CustomHeader title={'Last Update'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '10%',
        render: (typology) => (
          <TextComponent id={convertISOToDateFormat(typology.updatedTime)} />
        )
      },
      {
        title: <CustomHeader title={'FinCrime Type'} />,
        dataIndex: 'typology',
        className: style.bgWhite,
        key: 'typology',
        width: '21%',
        render: (typology) => (
          <TextComponent
            id={
              typology.sourceId === TM_FRAUD_SOURCE_IDS.TM
                ? TM_FRAUD_PREVENTION_SOURCE_MAPPING.TM_AML
                : typology.sourceId === TM_FRAUD_SOURCE_IDS.FRAUD_PREVENTION_ID
                ? TM_FRAUD_PREVENTION_SOURCE_MAPPING.FRAUD_PREVENTION
                : TM_FRAUD_PREVENTION_SOURCE_MAPPING.FRAUD_DETECTION
            }
          />
        )
      }
    ];

    // this.preventioncolumns = [
    //   {
    //     title: '',
    //     className: style.bgWhite,
    //     width: '10%',
    //     render: (typology) => (
    //       <AddToBucketComponent
    //         {...typology}
    //         onAddTypologyToScenario={this.onAddTypologyToRunInstance}
    //       />
    //     )
    //   },
    //   {
    //     title: <CustomHeader title={'Typology ID'} />,
    //     dataIndex: 'typology',
    //     className: style.bgWhite,
    //     key: 'typology',
    //     width: '10%',
    //     render: (typology) => (
    //       <TextComponent style={{ color: '#0C8ED7' }} id={typology.id} />
    //     )
    //   },
    //   {
    //     title: <CustomHeader title={'Typology Name'} />,
    //     dataIndex: 'typology',
    //     width: '35%',
    //     className: style.bgWhite,
    //     key: 'typology',
    //     render: (typology) => <TextComponent id={typology.title} />
    //   },
    //   {
    //     title: <CustomHeader title={'Typology Description'} />,
    //     dataIndex: 'notes',
    //     width: '10%',
    //     className: style.bgWhite,
    //     key: 'notes',
    //     render: (notes) => <NotesComponent notes={notes} />
    //   },
    // ];
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    const preventionResourceAccess = hasAttributeValue(
      this.props.authenticationStateObject,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
      TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
    );
    const detectionResourceAccess = hasAttributeValue(
      this.props.authenticationStateObject,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
      TM_FRAUD_SOURCE_IDS.TM
    );

    const fraudResourceAccess = hasAttributeValue(
      this.props.authenticationStateObject,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
      TM_FRAUD_SOURCE_IDS.FRAUD
    );

    this.setState({ preventionAccess: preventionResourceAccess });
    this.setState({ detectionAccess: detectionResourceAccess });
    this.setState({ fraudAccess: fraudResourceAccess });

    const userAccess = returnFraudUserAccessByResource(
      this.props.authentication,
      trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
      ITEM_OPERATIONS.READ
    );
    this.setState({
      isTMuser: userAccess.isTMuser,
      isFraud: userAccess.isFraud
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Recompute access flags when auth state changes (e.g., module switch)
    if (
      prevProps.authenticationStateObject?.data !==
      this.props.authenticationStateObject?.data
    ) {
      const preventionResourceAccess = hasAttributeValue(
        this.props.authenticationStateObject,
        trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
        TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
      );
      const detectionResourceAccess = hasAttributeValue(
        this.props.authenticationStateObject,
        trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
        TM_FRAUD_SOURCE_IDS.TM
      );
      const fraudResourceAccess = hasAttributeValue(
        this.props.authenticationStateObject,
        trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
        TM_FRAUD_SOURCE_IDS.FRAUD
      );
      this.setState({
        preventionAccess: preventionResourceAccess,
        detectionAccess: detectionResourceAccess,
        fraudAccess: fraudResourceAccess
      });

      const userAccess = returnFraudUserAccessByResource(
        this.props.authentication,
        trmResources.APP_3_RESOURCE_UI_TYPOLOGY,
        ITEM_OPERATIONS.READ
      );
      this.setState({
        isTMuser: userAccess.isTMuser,
        isFraud: userAccess.isFraud
      });
    }

    if (
      this.state.preventionAccess !== prevState.preventionAccess ||
      this.state.detectionAccess !== prevState.detectionAccess ||
      this.state.fraudAccess !== prevState.fraudAccess
    ) {
      if (this.state.preventionAccess && !this.state.detectionAccess) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
        });
        this.setState({
          currentModuleSource: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
        });
      } else if (!this.state.preventionAccess && this.state.detectionAccess) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.TM
        });
        this.setState({ currentModuleSource: TM_FRAUD_SOURCE_IDS.TM });
      } else if (this.state.fraudAccess && !this.state.detectionAccess) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
        });
        this.setState({ currentModuleSource: TM_FRAUD_SOURCE_IDS.FRAUD });
      } else if (this.state.preventionAccess && this.state.detectionAccess) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.TM
        });
        this.setState({ currentModuleSource: TM_FRAUD_SOURCE_IDS.TM });
      }
    }
  }

  onAddTypologyToRunInstance = (typologyObject) => {
    this.setState({
      showRunInstanceModal: !this.state.showRunInstanceModal,
      selectedTypology: typologyObject
    });
  };

  /**
   * getDerivedStateFromProps
   * @param nextProps
   * @returns {null|{trmTypologies: ([]|*[]|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data, error: null}|*)}}
   */
  static getDerivedStateFromProps(nextProps) {
    const { trmDashboard } = nextProps;

    if (trmDashboard && trmDashboard.trmTypologies) {
      return {
        trmTypologies: trmDashboard.trmTypologies
      };
    }
    return null;
  }

  /**
   * onDrawerOpen
   * @param defaultTab
   */
  onDrawerOpen = (defaultTab = 0) => {
    this.drawerRef.current.showDrawer(defaultTab);
  };

  onPaginationChange = (page, pageSize) => {
    this.setState({ defaultCurrent: page, pageSize });
    if (this.state.currentSelectedFilter == 'Fraud') {
      this.props.fetchTypologiesData({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
      });
    } else if (this.state.currentSelectedFilter == 'TM') {
      this.props.fetchTypologiesData({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM
      });
    } else if (this.state.currentSelectedFilter == 'TMFRAUD') {
      this.props.fetchTypologiesData({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM_FRAUD_ID
      });
    } else if (this.state.currentSelectedFilter == 'TMPREV') {
      this.props.fetchTypologiesData({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM_PREV_ID
      });
    } else if (this.state.currentSelectedFilter == 'PREV') {
      this.props.fetchTypologiesData({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID
      });
    } else {
      this.props.fetchTypologiesData({
        page,
        pageSize
      });
    }
  };

  onDropDownFilterChange = (selectedValue) => {
    this.setState(
      {
        currentSelectedFilter: selectedValue,
        defaultCurrent: 1,
        pageSize: 20
      },
      () => {
        if (selectedValue === 'Fraud') {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize,
            sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
          });
        } else if (selectedValue === 'TM') {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize,
            sourceId: TM_FRAUD_SOURCE_IDS.TM
          });
        } else if (selectedValue === 'All') {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize
          });
        }
      }
    );
  };

  onFilterChange = (value) => {
    if (value === 'All') {
      if (this.state.detectionAccess && this.state.fraudAccess) {
        this.setState({
          currentSelectedFilter: 'TMFRAUD'
        });
        this.setState(
          {
            defaultCurrent: 1
          },
          () => {
            this.props.fetchTypologiesData({
              page: this.state.defaultCurrent,
              pageSize: this.state.pageSize,
              sourceId: TM_FRAUD_SOURCE_IDS.TM_FRAUD_ID
            });
          }
        );
      } else if (this.state.detectionAccess && this.state.preventionAccess) {
        this.setState({
          currentSelectedFilter: 'TMPREV'
        });
        this.setState(
          {
            defaultCurrent: 1
          },
          () => {
            this.props.fetchTypologiesData({
              page: this.state.defaultCurrent,
              pageSize: this.state.pageSize,
              sourceId: TM_FRAUD_SOURCE_IDS.TM_PREV_ID
            });
          }
        );
      }
    } else if (value === 'TM') {
      this.setState({
        currentSelectedFilter: 'TM'
      });
      this.setState(
        {
          defaultCurrent: 1
        },
        () => {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize,
            sourceId: TM_FRAUD_SOURCE_IDS.TM
          });
        }
      );
    } else if (value === 'Fraud') {
      this.setState({
        currentSelectedFilter: 'Fraud'
      });
      this.setState(
        {
          defaultCurrent: 1
        },
        () => {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize,
            sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
          });
        }
      );
    } else if (value === 'Surveillance') {
      this.setState({
        currentSelectedFilter: 'PREV'
      });
      this.setState(
        {
          defaultCurrent: 1
        },
        () => {
          this.props.fetchTypologiesData({
            page: this.state.defaultCurrent,
            pageSize: this.state.pageSize,
            sourceId: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
          });
        }
      );
    }
  };

  handleTabChange = (activeKey) => {
    // this.setState({ activeTab: activeKey });
    if (activeKey === '1') {
      this.props.fetchTypologiesData({
        page: this.state.defaultCurrent,
        pageSize: this.state.pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM
      });
      this.setState({ currentModuleSource: TM_FRAUD_SOURCE_IDS.TM });
    } else if (activeKey === '2') {
      this.props.fetchTypologiesData({
        page: this.state.defaultCurrent,
        pageSize: this.state.pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
      });
      this.setState({
        currentModuleSource: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
      });
    }
  };

  render() {
    const { trmTypologies, defaultCurrent, pageSize } = this.state;
    const { isLoading = true, data = null } = trmTypologies || {};
    const { Search } = Input;
    let typologyList = [];
    let typologyCount = 0;
    if (!isLoading && data) {
      typologyList = data.typologies;
      typologyCount = data.totalCount;
    }

    const onSearch = (value) => {
      if (this.state.currentModuleSource === TM_FRAUD_SOURCE_IDS.TM) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.TM,
          searchTerms: value
        });
      } else if (
        this.state.currentModuleSource === TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
      ) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD,
          searchTerms: value
        });
      } else if (
        this.state.currentModuleSource ===
        [TM_FRAUD_SOURCE_IDS.TM, TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD]
      ) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: [
            TM_FRAUD_SOURCE_IDS.TM,
            TM_FRAUD_SOURCE_IDS.REAL_TIME_FRAUD
          ],
          searchTerms: value
        });
      } else if (this.state.currentModuleSource === TM_FRAUD_SOURCE_IDS.FRAUD) {
        this.props.fetchTypologiesData({
          page: this.state.defaultCurrent,
          pageSize: this.state.pageSize,
          sourceId: TM_FRAUD_SOURCE_IDS.FRAUD,
          searchTerms: value
        });
      }
    };

    return (
      <Layout className="layout">
        <PageHeader
          ghost={false}
          title="Typology Listing"
          extra={[
            // this.state.isFraud && this.state.isTMuser ? (
            //   <Select
            //     options={[
            //       { value: 'All', label: 'All' },
            //       { value: 'TM', label: 'TM' },
            //       { value: 'Fraud', label: 'Fraud' }
            //     ]}
            //     style={{ width: '150px' }}
            //     defaultValue="All"
            //     onChange={(e) => this.onDropDownFilterChange(e)}
            //   />
            // ) : (
            //   ''
            // ),
            <TTButton
              btnType={'secondary'}
              icon={<UploadOutlined />}
              style={{ backgroundColor: 'white', width: 'auto' }}
              btnText={'Upload Typology'}
              routeToGo={'/app/trm/upload'}
            />,
            <TTButton
              btnType={'secondary'}
              icon={
                <img
                  src={RightCaret}
                  style={{
                    height: 12,
                    width: 12,
                    marginRight: 10
                  }}
                  alt={RightCaret}
                />
              }
              style={{ backgroundColor: 'white', width: 'auto' }}
              btnText={'Configure Run Instance'}
              routeToGo={'/app/trm/run-instance'}
            />
          ]}></PageHeader>

        <Content>
          <Tabs
            className={style.typologyTabs}
            activeKey={this.state.activeTab}
            onChange={this.handleTabChange}>
            {this.state.detectionAccess === true ||
            this.state.fraudAccess === true ? (
              <TabPane tab="Detection" key="1">
                <Space
                  size={5}
                  direction="vertical"
                  style={{ width: '100%', backgroundColor: '#BEC3CA' }}>
                  <Content className={style.site_layout_background}>
                    <div className={style.selectFilters}>
                      <Search
                        className={style.searchTypology}
                        placeholder="Please input the typology name"
                        onSearch={onSearch}
                        enterButton
                      />
                      {this.state.detectionAccess && this.state.fraudAccess && (
                        <FilterDropdown
                          detectionAccess={this.state.detectionAccess}
                          fraudAccess={this.state.fraudAccess}
                          preventionAccess={this.state.preventionAccess}
                          onFilterChange={this.onFilterChange}
                        />
                      )}
                    </div>
                    <Table
                      className={style.typologyListTable}
                      loading={isLoading}
                      columns={this.columns}
                      pagination={{
                        total: typologyCount,
                        current: defaultCurrent,
                        onChange: this.onPaginationChange,
                        pageSize,
                        showSizeChanger: true
                      }}
                      rowClassName={style.tableRowClass}
                      dataSource={typologyList}
                    />
                  </Content>
                </Space>
              </TabPane>
            ) : (
              <TabPane tab="Prevention" key="2">
                <Space
                  size={5}
                  direction="vertical"
                  style={{ width: '100%', backgroundColor: '#BEC3CA' }}>
                  <Content className={style.site_layout_background}>
                    <div className={style.selectFilters}>
                      <Search
                        className={style.searchTypology}
                        placeholder="Enter name, description to search"
                        onSearch={onSearch}
                        enterButton
                      />
                      {this.state.detectionAccess &&
                        this.state.preventionAccess && (
                          <FilterDropdown
                            detectionAccess={this.state.detectionAccess}
                            fraudAccess={this.state.fraudAccess}
                            preventionAccess={this.state.preventionAccess}
                            onFilterChange={this.onFilterChange}
                          />
                        )}
                    </div>

                    <Table
                      className={style.typologyListTable}
                      loading={isLoading}
                      columns={this.columns}
                      pagination={{
                        total: typologyCount,
                        current: defaultCurrent,
                        onChange: this.onPaginationChange,
                        pageSize
                      }}
                      rowClassName={style.tableRowClass}
                      dataSource={typologyList}
                    />
                  </Content>
                </Space>
              </TabPane>
            )}

            {/* {this.state.preventionAccess === true ? (
              <TabPane tab="Prevention" key="2">
                <Space
                  size={5}
                  direction="vertical"
                  style={{ width: '100%', backgroundColor: '#BEC3CA' }}>
                  <Content className={style.site_layout_background}>
                    <div className={style.selectFilters}>
                      <Search
                        className={style.searchTypology}
                        placeholder="Enter name, description to search"
                        onSearch={onSearch}
                        enterButton
                      />
                      {this.state.detectionAccess &&
                        this.state.preventionAccess && (
                          <FilterDropdown
                            detectionAccess={this.state.detectionAccess}
                            fraudAccess={this.state.fraudAccess}
                            preventionAccess={this.state.preventionAccess}
                            onFilterChange={this.onFilterChange}
                          />
                        )}
                    </div>

                    <Table
                      loading={isLoading}
                      columns={this.columns}
                      pagination={{
                        total: typologyCount,
                        current: defaultCurrent,
                        onChange: this.onPaginationChange,
                        pageSize
                      }}
                      rowClassName={style.tableRowClass}
                      dataSource={typologyList}
                    />
                  </Content>
                </Space>
              </TabPane>
            ) : (
              ''
            )} */}
          </Tabs>

          <TRMDrawer tabsConfig={typologyTabsConfig} ref={this.drawerRef} />
          {this.state.showRunInstanceModal && this.state.selectedTypology && (
            <RunInstanceHandlerClass
              onClose={this.onAddTypologyToRunInstance}
              typologyObject={this.state.selectedTypology}
              isModalVisible={this.state.showRunInstanceModal}
            />
          )}
        </Content>
      </Layout>
    );
  }
}

const FilterDropdown = ({
  detectionAccess,
  fraudAccess,
  preventionAccess,
  onFilterChange
}) => {
  return (
    <Dropdown
      overlay={
        <FilterMenu
          detectionAccess={detectionAccess}
          fraudAccess={fraudAccess}
          preventionAccess={preventionAccess}
          onMenuClick={onFilterChange}
        />
      }
      trigger={['click']}
      placement="bottomRight">
      <Button>
        <FilterOutlined />
      </Button>
    </Dropdown>
  );
};

export default TRM_Dashboard;
